var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 182,
    viewBox: "0 0 144 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.364 149.841L117.502 127.979C114.108 124.585 109.491 122.684 104.693 122.684H98.6275L89.5749 127.21H71.4696C66.4907 127.21 62.417 131.284 62.417 136.263V145.315",
    stroke: "#3F4D61",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.207 177.003L103.154 167.951H48.8384L8.10156 127.214L15.2079 125.448C22.1332 123.728 29.5111 125.313 35.0784 129.794L53.3647 145.319H89.5753",
    stroke: "#3F4D61",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8486 95.5267L66.9434 100.053L57.8907 109.106H48.8381L39.7855 100.053L30.7329 109.106H21.6802L12.6276 100.053L4.9781 61.7604C4.07284 57.2794 4.97809 52.6625 7.51283 48.8604C10.6812 44.0625 16.0676 41.2109 21.816 41.2109H57.8907",
    stroke: "#3F4D61",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7851 41.2107L30.7324 23.1055",
    stroke: "#3F4D61",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2946 40.9844C92.7883 31.6149 85.5009 23.1055 75.9956 23.1055C66.4904 23.1055 59.2483 31.6149 60.6967 40.9844L70.7451 104.624C71.1525 107.204 73.3704 109.105 75.9956 109.105C78.6209 109.105 80.8388 107.204 81.2462 104.624L91.2946 40.9844Z",
    stroke: "#3F4D61",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4697 9.52632L75.996 23.1053L85.0487 5",
    stroke: "#3F4D61",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.7030ceaa3a7b25ec4b5e122b8cf66d53.svg";
export { ForwardRef as ReactComponent };